import dispatcher from 'core/dispatcher';

export default function publish(action, payload) {
  dispatcher.trigger(action, payload);
}
